module.exports = __webpack_public_path__ + "media/images/flags/ba-7097f2f878560a3debc6d5fd27807596.svg";